import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=2e190e4e&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=2e190e4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e190e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e190e4e')) {
      api.createRecord('2e190e4e', component.options)
    } else {
      api.reload('2e190e4e', component.options)
    }
    module.hot.accept("./DocumentViewer.vue?vue&type=template&id=2e190e4e&scoped=true", function () {
      api.rerender('2e190e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/DocumentViewer.vue"
export default component.exports